// Sometimes Booking engine is opened at URL with a double slash - https://api.mews.com//distributor/[configurationId]. Let's remove it because it causes an error "SecurityError: Failed to execute 'replaceState' on 'History'".
export const sanitizePathname = (url: string) =>
    // removes double slashes from the beginning of the URL
    url.replace(/^\/\//, '/');

export const getUrlPathWithParams = (url: URL, params: Record<string, string>) => {
    const newUrl = new URL(url.href);
    Object.entries(params).forEach(([key, value]) => {
        newUrl.searchParams.set(key, value);
    });

    return `${sanitizePathname(newUrl.pathname)}${newUrl.search}${newUrl.hash}`;
};
